module.exports = __webpack_public_path__ + "img/mobile-nav-1.9d98f193.png";